import "../style/store/Store.css";
import SFilter from "./S_Filter";
import SProducts from "./S_Products";
import SSearch from "./S_Search";
import SSort from "./S_Sort";
import { useSelector } from "react-redux";
// import { useState } from 'react';

const Store = () => {
  const state = useSelector((state) => state.default);
  // const [openNav_is_change,set_openNav_is_change]=useState(false);

  if (state.openNav === "open") {
    document.querySelector(".store-main").classList.add("store-main-won");
  } else if (state.openNav === "close") {
    if (document.querySelector(".store-main") !== null) {
      document.querySelector(".store-main").classList.remove("store-main-won");
    }
  }

  return (
    <div className="Store">
      <div className="store-main">
        <SSearch />
        <SSort />
        <div className="store-main-line"></div>
        <SFilter />
        <SProducts />
      </div>
    </div>
  );
};

export default Store;
